import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class UserNotificationVm {
	userNotificationId: number;
	userId: number;
	dailyCount: boolean;
	missedDailyCount: boolean;
	businessDaysReminder: boolean;
	friendlyId?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'userNotificationId': new UntypedFormControl(0, [...(validators['userNotificationId'] ?? []), ...[Validators.required]]),
			'userId': new UntypedFormControl(0, [...(validators['userId'] ?? []), ...[Validators.required]]),
			'dailyCount': new UntypedFormControl(false, [...(validators['dailyCount'] ?? []), ...[]]),
			'missedDailyCount': new UntypedFormControl(false, [...(validators['missedDailyCount'] ?? []), ...[]]),
			'businessDaysReminder': new UntypedFormControl(false, [...(validators['businessDaysReminder'] ?? []), ...[]]),
			'friendlyId': new UntypedFormControl(null, [...(validators['friendlyId'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): UserNotificationVmFromFg {
		return new UserNotificationVmFromFg(fg);
	}
}

export class UserNotificationVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get userNotificationId(): number {
		return this.fg.get('userNotificationId').value;
	}
	set userNotificationId(val) {
		this.fg.get('userNotificationId').setValue(val);
	}

	get userId(): number {
		return this.fg.get('userId').value;
	}
	set userId(val) {
		this.fg.get('userId').setValue(val);
	}

	get dailyCount(): boolean {
		return this.fg.get('dailyCount').value;
	}
	set dailyCount(val) {
		this.fg.get('dailyCount').setValue(val);
	}

	get missedDailyCount(): boolean {
		return this.fg.get('missedDailyCount').value;
	}
	set missedDailyCount(val) {
		this.fg.get('missedDailyCount').setValue(val);
	}

	get businessDaysReminder(): boolean {
		return this.fg.get('businessDaysReminder').value;
	}
	set businessDaysReminder(val) {
		this.fg.get('businessDaysReminder').setValue(val);
	}

	get friendlyId(): string {
		return this.fg.get('friendlyId').value;
	}
	set friendlyId(val) {
		this.fg.get('friendlyId').setValue(val);
	}
}
